module.exports = "<div [id]=\"containerId\" class=\"stadium-camera-360-container\"></div>\n<context-menu *ngIf=\"isAdmin\">\n    <ng-template contextMenuItem [enabled]=\"contextMenuCanEdit\" (execute)=\"onSelectCamera.emit($event.item)\">\n        Edit\n    </ng-template>\n    <ng-template contextMenuItem (execute)=\"contextMenuDelete($event.item)\">\n        Delete\n    </ng-template>\n</context-menu>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/stadium-camera-360/stadium-camera-360.component.html
// module id = ./src/app/shared/components/stadium-camera-360/stadium-camera-360.component.html
// module chunks = main